var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sun"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 122.667C103.564 122.667 122.667 103.564 122.667 80C122.667 56.4359 103.564 37.3333 80 37.3333C56.4358 37.3333 37.3333 56.4359 37.3333 80C37.3333 103.564 56.4358 122.667 80 122.667Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 29.3333C85.6 24.4 88 15.9467 88 9.01333C88 2.10667 84 0 80 0C76 0 72 2.10667 72 9.01333C72 15.92 74.4 24.3733 80 29.3333Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 36.1333C57.4933 29.84 56.4267 23.1733 53.6 18.2667C50.7733 13.36 46.1333 13.3333 42.6667 15.3333C39.2 17.3333 36.9067 21.36 39.7333 26.2667C42.56 31.1733 47.7867 35.44 54.6667 36.1333Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2 54.6667C33.7067 47.36 27.44 41.04 21.3333 37.5733C15.2267 34.1067 11.3067 36.5333 9.28 40C7.22667 43.4667 7.06667 47.9733 13.1733 51.44C19.28 54.9067 28 57.04 35.2 54.6667Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 80C25.3067 74.4 18.9867 72 13.3333 72C7.68 72 5.33334 76 5.33334 80C5.33334 84 7.68 88 13.3333 88C18.9867 88 25.3067 85.6 29.3333 80Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2 105.333C27.9733 102.96 19.28 105.093 13.1733 108.56C7.06667 112.027 7.22667 116.533 9.28 120C11.3333 123.467 15.2267 125.867 21.3333 122.427C27.44 118.987 33.7067 112.667 35.2 105.333Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 123.893C47.7867 124.587 42.56 128.853 39.7333 133.76C36.9067 138.667 39.2 142.693 42.6667 144.693C46.1333 146.693 50.7733 146.667 53.6 141.76C56.4267 136.853 57.4933 130.213 54.6667 123.893Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 130.667C74.4 135.6 72 144.053 72 150.987C72 157.92 76 160 80 160C84 160 88 157.893 88 150.987C88 144.08 85.6 135.627 80 130.667Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.333 123.867C102.507 130.16 103.573 136.827 106.4 141.733C109.227 146.64 113.867 146.667 117.333 144.667C120.8 142.667 123.093 138.64 120.267 133.733C117.44 128.827 112.213 124.56 105.333 123.867Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 105.333C126.293 112.64 132.56 118.96 138.667 122.427C144.773 125.893 148.693 123.467 150.72 120C152.773 116.533 152.933 112.027 146.827 108.56C140.72 105.093 132 102.96 124.8 105.333Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.667 80C134.693 85.6 141.013 88 146.667 88C152.32 88 154.667 84 154.667 80C154.667 76 152.32 72 146.667 72C141.013 72 134.693 74.4 130.667 80Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 54.6667C132.027 57.04 140.72 54.9067 146.827 51.44C152.933 47.9733 152.773 43.4667 150.72 40C148.667 36.5333 144.773 34.1333 138.667 37.5733C132.56 41.04 126.293 47.3333 124.8 54.6667Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.333 36.1067C112.213 35.4133 117.44 31.1467 120.267 26.24C123.093 21.3333 120.8 17.3067 117.333 15.3067C113.867 13.3067 109.227 13.3333 106.4 18.24C103.573 23.1467 102.507 29.7867 105.333 36.1067Z",
    fill: "var(--fill-0, #7A9D6B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8 52.6933C106.96 49.68 100.347 48 93.3333 48C69.76 48 50.6667 67.0933 50.6667 90.6667C50.6667 101.067 54.3733 110.587 60.5333 117.973C46.7467 110.907 37.3333 96.56 37.3333 80C37.3333 56.4267 56.4267 37.3333 80 37.3333C93.1733 37.3333 104.96 43.3067 112.8 52.6933Z",
    fill: "var(--fill-0, #7A9D6B)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSun);
export default __webpack_public_path__ + "static/media/cta_sun.4f3f0e4123bfe71b56d575987cc202bf.svg";
export { ForwardRef as ReactComponent };